import axios from '@/api/axios'

const getSportFederations = () => {
    return axios.get(`/sportsFederations`)
}

const addSportFederations = federations => {
    return axios.post(`/sportsFederations`, federations)
}

const updateSportFederations = federation => {
    return axios.put(`/sportsFederations/${federation.id}`, federation)
}

const getSportFederation = id => {
    return axios.get(`/sportsFederations/${id}`)
}

const deleteSportFederation = id => {
    return axios.delete(`/sportsFederations/${id}`)
}

export default {
    getSportFederations,
    addSportFederations,
    getSportFederation,
    updateSportFederations,
    deleteSportFederation
}
